"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Money_1 = __importDefault(require("components/Money"));
var LoadingNotification_1 = __importDefault(require("./LoadingNotification"));
var ScanServices = function (_a) {
    var notifications = _a.notifications;
    var notif = notifications[0];
    if ((notif === null || notif === void 0 ? void 0 : notif.toolsDetected) === undefined) {
        return ((0, jsx_runtime_1.jsx)(LoadingNotification_1.default, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["We are ", (0, jsx_runtime_1.jsx)("strong", { children: "scanning" }), " your expenses and ", (0, jsx_runtime_1.jsx)("strong", { children: "mapping" }), " them to software tools."] }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["We have detected ", (0, jsx_runtime_1.jsxs)("strong", { children: [notif.toolsDetected, " tools"] }), " and a spend on software of", ' ', (0, jsx_runtime_1.jsx)("strong", { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: notif.spend12Months }) }), " in the ", (0, jsx_runtime_1.jsx)("strong", { children: "last 12 months" }), "."] }));
};
exports.default = ScanServices;
